export function getStorageJson (key, fallback = {}) {
  try {
    const rawValue = localStorage.getItem(key)
    if (!rawValue) return fallback

    const parsedValue = JSON.parse(rawValue)
    return parsedValue && typeof parsedValue === 'object' ? parsedValue : fallback
  } catch (error) {
    return fallback
  }
}

export function setStorageJson (key, value) {
  localStorage.setItem(key, JSON.stringify(value))
}
